/* 
🌌 Shell UI Design System - Badge Components
Purpose: Status badges and tags with consistent styling
*/

import React from 'react';

export const Badge = ({ 
  children, 
  variant = 'primary', 
  className = '',
  ...props 
}) => {
  const baseClass = 'shell-badge';
  const variantClass = `${baseClass}--${variant}`;
  
  const combinedClassName = [baseClass, variantClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={combinedClassName} {...props}>
      {children}
    </span>
  );
};

export const PrimaryBadge = ({ children, ...props }) => (
  <Badge variant="primary" {...props}>{children}</Badge>
);

export const SuccessBadge = ({ children, ...props }) => (
  <Badge variant="success" {...props}>{children}</Badge>
);

export const WarningBadge = ({ children, ...props }) => (
  <Badge variant="warning" {...props}>{children}</Badge>
);

export const ErrorBadge = ({ children, ...props }) => (
  <Badge variant="error" {...props}>{children}</Badge>
);

export const StatusBadge = ({ status, children, ...props }) => {
  const statusVariant = {
    online: 'success',
    offline: 'error',
    pending: 'warning',
    active: 'primary'
  }[status] || 'primary';
  
  return (
    <Badge variant={statusVariant} {...props}>
      {children || status}
    </Badge>
  );
};

export default Badge;